import { render, staticRenderFns } from "./sthi.vue?vue&type=template&id=b31d319c&"
import script from "./sthi.js?vue&type=script&lang=js&"
export * from "./sthi.js?vue&type=script&lang=js&"
import style0 from "./sthi.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports